import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, DOC_ANALYSIS_ENDPOINTS } from "../apiEndpoints";

export const uploadDocumentAnalysisFileApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_ANALYSIS_ENDPOINTS.UPLOAD}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const documentAnalysisChatStreamApi = (document, docType, conversationHistory, signal) => {
  const url = `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_ANALYSIS_ENDPOINTS.DOCUMENT_CHAT}?stream=true`;
  return apiClient.stream(
    url,
    {
      document,
      doc_type: docType,
      conversation_history: conversationHistory,
    },
    signal
  );
};

export const generateDocumentAnalysisDocxApi = (cardType, data, docTitle) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_ANALYSIS_ENDPOINTS.GENERATE_DOCX}`,
    { card_type: cardType, data, doc_title: docTitle },
    { responseType: "blob" }
  );

export const getDocumentAnalysisRecommendationsApi = () =>
  apiClient.get(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_ANALYSIS_ENDPOINTS.RECOMMENDATIONS}`);
